import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { colorToArray, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import SaveButton from '../../components/builder/SaveButton';

import PromoColsWrapper from '../../components/front/PromoColsWrapper';
import Spinner from '../builder/Spinner.js';
import ProgressBar from '../builder/ProgressBar.js';

const DirectParticipation = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props.stage.Stage;
	const is_builder = props?.is_builder ?? false;
	const counter_ini = stage?.direct_splash_time ?? 3;

	const [ counter, setCounter ] = useState(stage?.direct_splash_time ?? 3);

	useEffect(() => {
		let to;

		if(stage.direct_type == undefined) stage.direct_type = 'splash';

		return () => {
			clearTimeout(to);
		}
	}, []);

	useEffect(() => {
		let cd;

		if(!['button'].includes(stage.direct_type)) {
			cd = setInterval(() => {
				if(counter <= 0) {
					if(!is_builder) props.participate();
					clearTimeout(cd);
					return;
				}

				setCounter(parseInt(counter) - 1);
			}, 1000);
		}

		return () => {
			clearTimeout(cd);
		}
	}, [ counter ]);

	const btn_text = (isNotEmpty(stage, 'direct_btn_text')) ? stage.direct_btn_text : "Enter";
	const direct_description = (isNotEmpty(stage, 'direct_description')) ? stage.direct_description : i18n("Registering the participation...");

	const main_color = stage?.direct_color ?? (props?.promotion?.Promotion?.layout_props?.color?.main_color ?? false);

	return (
		<PromoColsWrapper
			main_image={stage?.direct_image && stage.full_direct_image}
			main_video={stage.main_video}
			main_description={direct_description}
			extra_classes="gui_direct_participation"
		>
			<article class="template_module info_flexwrap gui_main_actions">
				<div class="template_submodule mod_align_center call_to_action_flex in_bottom">
					{(stage.direct_type == 'button') && (
						<div class="flex_button gui_big_button">
							<SaveButton
								_fullclass=""
								onClick={(e, cb) => props.participate(cb)}
							>{btn_text}</SaveButton>
						</div>
					)}

					{(stage.direct_type == 'splash') && (
						<div
							class="flex_button gui_big_button gui_custom_color"
							style={{
								'--main-color':colorToArray(main_color),
							}}
						>
							<span class="time_to_redirect" style={{ width:'100%' }}>
								<span
									class="pusher"
								/>

								<span
									class="bar gui_is_animated"
									style={{
										width:`${(counter_ini - counter) * 100 / counter_ini}%`,
									}}
								/>
							</span>
						</div>
					)}

					{(['splash-2', 'splash-3'].includes(stage.direct_type)) && (
						<div style={{ maxWidth:'320px', width:'100%', margin:'0 auto' }}>
							<ProgressBar
								color='whiteColor'
								size={(stage.direct_type == 'splash-2') ? "big" : null}
								display_percent={false}
								display_percent_in_bar={false}
								animation_duration={`${counter_ini}s`}
								initial_width='0%'
								classes="partial_animation forced_value"
								style={{
									'--main-color':colorToArray(main_color),
								}}
							//	reinforcement_color='var(--ribbon-open-bg-color-rgb)'
							/>
						</div>
					)}

					{(stage.direct_type == 'spinner') && (
						<div class="gui_pos_rel">
							<Spinner
								color={(main_color !== false) ? main_color : null}
							/>
						</div>
					)}
				</div>
			</article>
		</PromoColsWrapper>
	)
};

export default injectIntl(DirectParticipation);